import flatpickr from "flatpickr";
import { French } from "flatpickr/dist/l10n/fr.js";
import IMask from "imask";
import "flatpickr/dist/flatpickr.min.css";
import "./date-picker.css";

// Date Picker Component
export default () => ({
    init() {
        const el = this.$el;
        const fp = flatpickr(el, {
            altInput: true,
            altFormat: "d.m.Y",
            dateFormat: "Y-m-d",
            static: true,
            appendTo: el.parentElement,
            locale: French,
            allowInput: true
        });

        const visibleInput = fp.altInput || el;
        IMask(visibleInput, {
            mask: Date,
            pattern: 'd.`m.`Y',
            blocks: {
                d: {mask: IMask.MaskedRange, from: 1, to: 31, maxLength: 2},
                m: {mask: IMask.MaskedRange, from: 1, to: 12, maxLength: 2},
                Y: {mask: IMask.MaskedRange, from: 1900, to: 2999 }
            },
            format: function (date) {
                const day = ('0' + date.getDate()).slice(-2);
                const month = ('0' + (date.getMonth() + 1)).slice(-2);
                const year = date.getFullYear();
                return `${day}.${month}.${year}`;
            },
            parse: function (str) {
                const [day, month, year] = str.split('.');
                return new Date(year, month - 1, day);
            },
            autofix: true
        });
    }
});
